import { RESET_ITEMS } from 'client/constants';

export function resetItems() {
	return {
		type: RESET_ITEMS,
	};
}
